// extracted by mini-css-extract-plugin
export default {"aboutUs":"AboutUs_aboutUs__kNmWN","content":"AboutUs_content__24hRx","imageContainer":"AboutUs_imageContainer__IL9Ie","image":"AboutUs_image__6ot5Z"};